import { api } from '../lib/api';

/**
 * LabService - Laboratório de geração de posts (Admin)
 *
 * Gera amostras de posts via Creatomate (modo canvas autônomo)
 * diretamente no backend, para iteração rápida do admin.
 */
export const labService = {

  /**
   * Gerar amostras de posts
   * @param {Object} params
   * @param {string} params.prompt - Briefing / intenção
   * @param {number} params.sample_count - Quantidade de amostras (1-15)
   * @param {string[]} [params.brand_colors] - Cores da marca (hex)
   * @param {Object} [params.brand_fonts] - {primary, secondary}
   * @param {string} [params.extra_instructions] - Instruções extras para o agente
   */
  async generateSamples(params) {
    const response = await api.post('/api/admin/lab/generate', params);
    return response.data;
  },

  /**
   * Listar sessões do lab
   * @param {number} limit
   */
  async listSessions(limit = 20) {
    const response = await api.get(`/api/admin/lab/sessions?limit=${limit}`);
    return response.data;
  },

  /**
   * Detalhes de uma sessão
   * @param {string} sessionId
   */
  async getSession(sessionId) {
    const response = await api.get(`/api/admin/lab/sessions/${sessionId}`);
    return response.data;
  },

  /**
   * Regenerar amostra com feedback
   * @param {string} sessionId
   * @param {string} sampleId
   * @param {string} feedback
   */
  async regenerateSample(sessionId, sampleId, feedback) {
    const response = await api.post(
      `/api/admin/lab/sessions/${sessionId}/samples/${sampleId}/regenerate`,
      { feedback }
    );
    return response.data;
  },

  /**
   * Buscar fila de review (amostras não validadas)
   * @param {number} limit - Max sessões a buscar
   */
  async getReviewQueue(limit = 50) {
    const response = await api.get(`/api/admin/lab/review/queue?limit=${limit}`);
    return response.data;
  },

  /**
   * Validar amostra (like/dislike/skip + feedback)
   * @param {string} sessionId
   * @param {string} sampleId
   * @param {Object} validation - { status: 'approved'|'rejected'|'skipped', feedback?: string }
   */
  async validateSample(sessionId, sampleId, { status, feedback }) {
    const response = await api.patch(
      `/api/admin/lab/sessions/${sessionId}/samples/${sampleId}/validate`,
      { status, feedback }
    );
    return response.data;
  },

  // ============================================
  // TEMPLATED.IO
  // ============================================

  /**
   * Listar templates disponíveis no Templated.io
   * @param {Object} [params] - Filtros opcionais
   * @param {string} [params.query] - Busca por nome
   * @param {string} [params.tags] - Filtrar por tags
   * @param {number} [params.limit] - Limite (default 50)
   * @param {number} [params.page] - Página (default 1)
   */
  async listTemplatedTemplates(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.query) queryParams.set('query', params.query);
    if (params.tags) queryParams.set('tags', params.tags);
    if (params.limit) queryParams.set('limit', params.limit);
    if (params.page) queryParams.set('page', params.page);
    const qs = queryParams.toString();
    const response = await api.get(`/api/admin/lab/templated/templates${qs ? `?${qs}` : ''}`);
    return response.data;
  },

  /**
   * Detalhes de um template Templated.io
   * @param {string} templateId
   */
  async getTemplatedTemplate(templateId) {
    const response = await api.get(`/api/admin/lab/templated/templates/${templateId}`);
    return response.data;
  }
};
